import { prop } from 'ramda';

import { employeesAdapter } from '@/adapters';

export const employeesEntitySelector = employeesAdapter.getSelectors<RootState>(prop('employees'));
